import "./BuyPackPopup.css";

export default function BuyPackPopup({ visible, onClose, onBuy, packName, totalInterviews }) {
    if (!visible) return null;

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                <h2>Buy {packName}</h2>
                <p>
                    This pack includes <strong>{totalInterviews}</strong> interviews.
                    Unlock full access by purchasing now.
                </p>

                <div className="popup-actions">
                    <button className="buy-btn" onClick={onBuy}>💳 Buy Now</button>
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}
